import { SVGProps } from 'react'

export const ArrowDown = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 20.999l7.071-7.071-1.768-1.768-4.054 4.055V2.998h-2.5v13.216L6.696 12.16l-1.768 1.768 7.07 7.071H12z"
      fill="currentColor"
    ></path>
  </svg>
)

export const OneLineSwapIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" cursor="pointer" {...props}>
      <path d="M7.5 3h3v18.5l-7-7h4V3zM16.5 21h-3V2.5l7 7h-4V21z" fill="currentColor"></path>
    </svg>
  )
}

export const CrossAccountConfigItemIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
    <path d="M21 3h-8v2h4.586L3 19.586 4.414 21 19 6.414V11h2V3z" fill="currentColor"></path>
    <path
      d="M4.414 3l6.168 6.168-1.414 1.414L3 4.414 4.414 3zM14.833 13.418L21 19.584v.002L19.586 21l-6.167-6.168 1.414-1.415z"
      fill="currentColor"
    ></path>
  </svg>
)

export const IsolatedAccountConfigItemIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
    <path d="M7.5 6.5a1 1 0 11-2 0 1 1 0 012 0z" fill="currentColor"></path>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.5 11a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm0-2a2.5 2.5 0 100-5 2.5 2.5 0 000 5z"
      fill="currentColor"
    ></path>
    <path d="M13 3h8v8h-2V6.414L4.414 21 3 19.586 17.586 5H13V3z" fill="currentColor"></path>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22 17.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2 0a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z"
      fill="currentColor"
    ></path>
  </svg>
)

export const MarginInfoIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 4c4.411 0 8 3.589 8 8s-3.589 8-8 8-8-3.589-8-8 3.589-8 8-8zm0-2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm.997 9.004h-2.009v6h2.009v-6zm-2.009-4h2.009v2.009h-2.009v-2.01z"
      fill="currentColor"
    ></path>
  </svg>
)

export const MarginRefreshIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.071 6.343C8.6 4.815 9.881 4 12 4a8 8 0 018 8h2c0-5.523-4.477-10-10-10-2.853 0-4.614 1.2-6.343 2.929L4 6.586V3H2v7h7V8H5.414l1.657-1.657zM16.929 17.657C15.4 19.185 14.119 20 12 20a8 8 0 01-8-8H2c0 5.523 4.477 10 10 10 2.852 0 4.614-1.2 6.343-2.929L20 17.414V21h2v-7h-7v2h3.586l-1.657 1.657z"
      fill="currentColor"
    ></path>
  </svg>
)

export const TransferIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M2 7l5.5 5.5 1.41-1.42L5.82 8H21V6H5.82l3.09-3.09L7.5 1.5 2 7zM22 17l-5.49-5.5-1.41 1.42L18.19 16H3v2h15.19l-3.09 3.08 1.41 1.41L22 17z"
      fill="#76808F"
    ></path>
  </svg>
)

export const BorrowRepayIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
    <path d="M7 12l5.5 5.5 1.41-1.42L10.82 13H21v-2H10.82l3.09-3.09L12.5 6.5 7 12z" fill="#76808F"></path>
    <path fillRule="evenodd" clipRule="evenodd" d="M3 3h18v2H5v14h16v2H3V3z" fill="#76808F"></path>
  </svg>
)

export const MarginTradeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
    <path d="M9 13.5l1.5 1.5L9 16.5 7.5 15 9 13.5z" fill="#76808F"></path>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.062 8.062A7.001 7.001 0 0122 9c0 3.548-2.64 6.48-6.062 6.938A7.001 7.001 0 012 15c0-3.548 2.64-6.48 6.062-6.938zM15 4a5 5 0 01.917 9.916 7.005 7.005 0 00-5.833-5.833A5.002 5.002 0 0115 4zm-6 6a5 5 0 110 10 5 5 0 010-10z"
      fill="#76808F"
    ></path>
  </svg>
)
